/* eslint-disable @typescript-eslint/no-explicit-any */

// Function to handle axios errors without automatic logout
export const handleAxiosError = (error: any) => {
  if (error.response?.status === 401 || error.response?.status === 404) {
    // Don't automatically logout, just log the error
  }
  throw error;
};


